import { useEffect, useState } from "react";
import { PortalShell, useUnread } from "@/components/portal/PortalShell";
import { ProductsTable } from "@/components/portal/ProductsTable";
import { OrdersPanel } from "@/components/portal/OrdersPanel";
import { LiveActivity } from "@/components/portal/LiveActivity";
import { ActAsPicker } from "@/components/portal/ActAsPicker";
import { useAuth } from "@/context/AuthContext";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

export default function ManufacturerPortal() {
  const { user } = useAuth();
  const isAdmin = !user || user.role === "admin";
  const [actAs, setActAs] = useState(() => localStorage.getItem("ao_act_as"));
  if (isAdmin && !actAs) return <ActAsPicker onPick={setActAs} />;
  return <MfrPortal key={actAs || "self"} isAdmin={isAdmin} reset={() => { localStorage.removeItem("ao_act_as"); setActAs(null); }} />;
}

function MfrPortal({ isAdmin, reset }) {
  const [tab, setTab] = useState("orders");
  const [products, setProducts] = useState([]);
  const [unread, refreshUnread] = useUnread();
  const load = () => api.get("/portal/products").then((r) => setProducts(r.data));

  useEffect(() => {
    load();
  }, []);

  const tabs = [
    { k: "orders", l: "Assigned orders", badge: unread },
    { k: "sarees", l: "My sarees" },
  ];

  return (
    <PortalShell title="Weaver portal" tabs={tabs} active={tab} setActive={setTab} unread={unread}>
      {isAdmin && (
        <div className="mb-6 flex flex-wrap items-center gap-3 rounded-sm border border-[#E06D3B]/40 bg-[#E06D3B]/10 px-4 py-3 text-sm" data-testid="act-as-banner">
          <span>You are viewing as a manufacturer (admin access).</span>
          <button onClick={reset} className="underline text-[#F3E5AB]" data-testid="act-as-switch">Switch manufacturer</button>
          <Link to="/admin" className="underline text-[#F3E5AB]" data-testid="act-as-exit">Back to admin</Link>
        </div>
      )}
      {tab === "orders" && (
        <>
          <p className="text-sm text-[#A89F91] mb-6">Accept orders assigned to you and send progress updates. The admin confirms each update before customers see it.</p>
          <OrdersPanel isAdmin={false} onRead={refreshUnread} />
          <div className="mt-8 max-w-2xl"><LiveActivity /></div>
        </>
      )}
      {tab === "sarees" && (
        <>
          <p className="text-sm text-[#A89F91] mb-6">New sarees go to the admin for approval. Deleting marks a saree out of stock.</p>
          <ProductsTable products={products} isAdmin={false} reload={load} />
        </>
      )}
    </PortalShell>
  );
}
